import { AfterViewInit, Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';

import { SelectItem } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import { Subject } from 'rxjs';

import { EquipamentoService } from '../../produto/equipamento/equipamento.service';
import { MaterialService } from '../../produto/material/material.service';
import { MedicamentoService } from '../../produto/medicamento/medicamento.service';
import { Produto } from '../../produto/produto/produto.model';
import { environment } from './../../../../environments/environment';
import { TipoProduto } from './../../../core/enums/produto.enum';
import { AutocompleteProdutoUtil } from './util/autocomplete-produto.util';

import * as $ from 'jquery';
import { ProdutoFilter } from '../../produto/produto/produto.filter';

export interface IProdutoComLabel {
  label: string;
  produto: Produto;
}

@Component({
  selector: 'app-autocomplete-produto',
  templateUrl: './autocomplete-produto.component.html',
  styleUrls: ['./autocomplete-produto.component.css']
})
export class AutocompleteProdutoComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() esconderTipoProduto: boolean;

  @Input() tipoProdutoSelecionado: string;

  @Input() autofocus = false;

  @Input() selecionarPrimeiro = true;

  @Input() produtoObrigatorio = false;

  @Input() formDisabled: boolean;

  @Input() paddingLeftZero = false;

  @Input() paddingTopZero = false;

  /* TODO: Criar 2 variaves:
           - placeholderProduto e placeholderTipoProduto
           - definir como padrão os placeholders Tipo e Produto,
             com a opção de esconder (pode ser outra propriedade)
  */
  @Input() placeholder: string;

  @ViewChild('produto') produtoViewChild: AutoComplete;

  @Input() filtroValidoEm: 'ESTOQUE' | 'INVENTARIO' | 'INVENTARIO_ESTOQUE';

  @Input() filtroIdUnidade: number;

  private debug = false; // !environment.production;

  produtoSelecionado: IProdutoComLabel;
  tipoProdutoSelecionadoDescricao: string;
  tipoProduto: SelectItem[];
  resultsetProdutos: IProdutoComLabel[];
  resultsetMaxSize = environment.localizador_max_size;

  private subject: Subject<Produto>;
  private subjectTipoOnChange: Subject<TipoProduto>;

  private autocompleteProdutoUtil: AutocompleteProdutoUtil;

  private produtoFilter: ProdutoFilter = {
    size: environment.localizador_max_size,
    status: 'A',
    sort: ['descricao,asc']
  };


  constructor(
    private materialService: MaterialService
    , private equipamentoService: EquipamentoService
    , private medicamentoService: MedicamentoService
  ) {
    this.subject = new Subject();
    this.subjectTipoOnChange = new Subject<TipoProduto>();
    this.autocompleteProdutoUtil = new AutocompleteProdutoUtil();
  }

  ngOnInit() {
    this.tipoProduto = [];
    // if ( this.exibirLimparTipo ) {
    //   this.tipoProduto.push({label: '', value: ''});
    // }
    this.tipoProduto.push({ label: 'Medicamento', value: TipoProduto.MEDICAMENTO.toString() });
    this.tipoProduto.push({ label: 'Material', value: TipoProduto.MATERIAL.toString() });
    this.tipoProduto.push({ label: 'Equipamento', value: TipoProduto.EQUIPAMENTO.toString() });

    if ( this.tipoProdutoSelecionado ) {
      this.tipoProdutoSelecionadoDescricao = this.tipoProdutoSelecionado;
    }
    else {
      this.tipoProdutoSelecionado = this.tipoProduto[0].value;
      this.tipoProdutoSelecionadoDescricao = this.tipoProduto[0].label;
    }

    this.limparDropDownProduto();
  }

  ngAfterViewInit(): void {
    this.setupExtraFilter();

    if ( this.autofocus && this.produtoViewChild ) {
      setTimeout(() => {
        this.produtoViewChild.focusInput();
      }, 200);
    }

    setTimeout(() => {
      if ( this.tipoProdutoSelecionado ) {
        this.subjectTipoOnChange.next(TipoProduto[this.tipoProdutoSelecionado]);
      }
    }, 200);
  }

  private setupExtraFilter(): void {
    // extra fitro do repositorio (estoque, inventario ou estoque e inventario)
    const extraFilterValidoEm = this.autocompleteProdutoUtil.getExtraFilterRepository(this.filtroValidoEm);
    if ( extraFilterValidoEm ) {
      this.autocompleteProdutoUtil.addExtraFilter(this.produtoFilter, extraFilterValidoEm);
    }

    if ( this.filtroIdUnidade ) {
      this.autocompleteProdutoUtil.addExtraFilter(this.produtoFilter, { idUnidade: this.filtroIdUnidade });
    }
  }

  ngOnDestroy(): void {
    if ( this.subject ) {
      this.subject.complete();
    }
    if ( this.subjectTipoOnChange ) {
      this.subjectTipoOnChange.complete();
    }
  }

  getSubject(): Subject<Produto> {
    return this.subject;
  }

  public getTipoProdutoSubject(): Subject<TipoProduto> {
    return this.subjectTipoOnChange;
  }

  static getProdutoDescricao(tipoProduto: TipoProduto): string {
    let produtoDescricao = '';
    switch (tipoProduto) {
      case TipoProduto.MEDICAMENTO.toString():
        produtoDescricao = 'Medicamento';
        break;
      case TipoProduto.MATERIAL.toString():
        produtoDescricao = 'Material';
        break;
      case TipoProduto.EQUIPAMENTO.toString():
        produtoDescricao = 'Equipamento';
        break;
      default:
        produtoDescricao = '';
        break;
    }

    return produtoDescricao;
  }

  public selecionarTipoProduto(tipoProduto: TipoProduto): void {
    switch (tipoProduto) {
      case TipoProduto.EQUIPAMENTO:
        this.tipoProdutoSelecionado = TipoProduto.EQUIPAMENTO;
        this.tipoProdutoSelecionadoDescricao = 'Equipamento';
        break;

      case TipoProduto.MATERIAL:
        this.tipoProdutoSelecionado = TipoProduto.MATERIAL;
        this.tipoProdutoSelecionadoDescricao = 'Material';
        break;

      case TipoProduto.MEDICAMENTO:
        this.tipoProdutoSelecionado = TipoProduto.MEDICAMENTO;
        this.tipoProdutoSelecionadoDescricao = 'Medicamento';
        break;

      default:
        this.limparDropDownProduto();
        break;
    }
  }

  getTipoProdutoSelecionado(): string {
    if ( this.debug ) { console.log('getTipoProdutoSelecionado', this.tipoProdutoSelecionado) };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };

    return this.tipoProdutoSelecionado;
  }

  onChangeTipoProduto(event: any) {
    if ( this.debug ) { console.log('onChangeTipoProduto') };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };

    const strTipoProduto = '' + event.value;
    const tipoProduto: TipoProduto = TipoProduto[strTipoProduto];
    this.tipoProdutoSelecionadoDescricao = AutocompleteProdutoComponent.getProdutoDescricao(tipoProduto);
    this.tipoProdutoSelecionado = tipoProduto;

    this.subjectTipoOnChange.next(tipoProduto);

    this.limparDropDownProduto();
  }

  limparDropDownProduto() {
    if ( this.debug ) { console.log('limparDropDownProduto') };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };

    this.produtoSelecionado = null;
    this.subject.next(null);
  }

  onSelectProduto(event: any): void {
    if ( this.debug ) { console.log('onSelectProduto', event.produto) };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };

    this.produtoSelecionado = {
      label: event.produto.descricao,
      produto: event.produto
    }
    this.subject.next(event.produto);
  }

  onBlurProduto(event: any) {
    if ( this.debug ) { console.log('onBlurProduto', event) };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };
  }

  onClearProduto() {
    if ( this.debug ) { console.log('onClearProduto') };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };

    this.limparDropDownProduto();
  }

  onFocusProduto(event: any) {
    if ( this.debug ) { console.log('onFocusProduto', event) };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };

    $('#autocompleteProduto').select();
  }

  appendExtraFilter(filter: ProdutoFilter): void {
    this.autocompleteProdutoUtil.addExtraFilter(this.produtoFilter, filter);
  }

  removeExtraFilter(key: string): void {
    this.autocompleteProdutoUtil.removeExtraFilter(this.produtoFilter, key);
  }

  searchProduto(event) {
    if ( this.debug ) { console.log('searchProduto', event.query) };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };

    this.produtoFilter.descricao = event.query;
    // console.log(this.produtoFilter);

    this.autocompleteProdutoUtil
        .searchProduto(
          TipoProduto[this.tipoProdutoSelecionado],
          this.produtoFilter,
          this.materialService,
          this.medicamentoService,
          this.equipamentoService
        )
        .subscribe(produtos => {
          this.resultsetProdutos = produtos;
        });
  }

  focusProduto(): void {
    if ( this.debug ) { console.log('focusProduto') };
    if ( this.debug ) { console.log('produtoSelecionado', this.produtoSelecionado) };

    if ( this.produtoViewChild ) {
      this.produtoViewChild.focusInput();
    }
  }
}
